import { axiosInstance } from './api'

import { EntityPage, Paging } from 'types/paging'
import { Publisher } from 'types/publisher'

export const publishersApi = {
  paging(params: Paging) {
    return axiosInstance.post<EntityPage<Publisher>>('publishers/paging', params)
  },
  publicPaging(params: Paging) {
    //remove auth header
    return axiosInstance.post<EntityPage<Publisher>>('publishers/paging', params)
  },
}
